import { tsUtils } from '@neo-one/ts-utils';
import { BuiltinInstanceMemberCall } from '../BuiltinInstanceMemberCall';
export class ArrayPop extends BuiltinInstanceMemberCall {
    canCall(_sb, _func, _node) {
        return true;
    }
    emitCall(sb, func, node, optionsIn, visited) {
        const options = sb.pushValueOptions(optionsIn);
        if (!visited) {
            sb.visit(tsUtils.expression.getExpression(func), options);
        }
        sb.emitHelper(node, options, sb.helpers.unwrapArray);
        sb.emitHelper(node, options, sb.helpers.if({
            condition: () => {
                sb.emitOp(node, 'DUP');
                sb.emitOp(node, 'ARRAYSIZE');
                sb.emitPushInt(node, 0);
                sb.emitOp(node, 'NUMEQUAL');
            },
            whenTrue: () => {
                sb.emitOp(node, 'DROP');
                sb.emitHelper(node, options, sb.helpers.wrapUndefined);
            },
            whenFalse: () => {
                sb.emitOp(node, 'DUP');
                sb.emitOp(node, 'ARRAYSIZE');
                sb.emitOp(node, 'DEC');
                sb.emitOp(node, 'SWAP');
                sb.emitOp(node, 'TUCK');
                sb.emitOp(node, 'OVER');
                sb.emitOp(node, 'PICKITEM');
                sb.emitOp(node, 'ROT');
                sb.emitOp(node, 'ROT');
                sb.emitOp(node, 'REMOVE');
            },
        }));
        if (!optionsIn.pushValue) {
            sb.emitOp(node, 'DROP');
        }
    }
}

//# sourceMappingURL=pop.js.map
